import React__default, { useState, useRef, useEffect } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Text } from '../../display/Text/Text.es.js';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import PageNavigationBadge from './PageNavigationBadge.es.js';
import PageNavigationRow from './PageNavigationRow.es.js';
import checkIsTruncated from './utils/checkIsTruncated.es.js';

const textContainer = "_text-container_1shez_1";
const textEllipsis = "_text-ellipsis_1shez_12";
const rowContainer = "_row-container_1shez_19";
const rowWrapper = "_row-wrapper_1shez_27";
const styles = {
	textContainer: textContainer,
	textEllipsis: textEllipsis,
	rowContainer: rowContainer,
	rowWrapper: rowWrapper
};

function NonNestedRow({ item, onSelect, showCount }) {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  useEffect(() => {
    setIsTruncated(checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const iconColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm6";
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const badgeVariant = hover || selected ? "primary-stronger" : "neutral";
    const textType = selected ? "Body3" : "Body1";
    return React__default.createElement(
      "div",
      { className: styles.rowContainer, "data-zds": true },
      React__default.createElement(
        "span",
        { className: styles.textContainer, "data-count-shown": Boolean(showCount), "data-zds": true },
        item.icon !== null && React__default.createElement(Icon, { color: iconColor, name: item.icon || "navFolder", size: 24 }),
        React__default.createElement(
          "span",
          { className: styles.textEllipsis, style: { "--_zds-nonnestedrow-textcolor": Colors[textColor] }, ref: textRef, "data-zds": true },
          React__default.createElement(Text, { color: textColor, margin: "0 0 0 8px", type: textType }, item.title)
        )
      ),
      item.count ? React__default.createElement(PageNavigationBadge, { variant: badgeVariant }, item.count.toString()) : null
    );
  };
  const Content = ({ hover, selected }) => {
    const innerContent = isTruncated ? React__default.createElement(TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast" }, () => React__default.createElement(InnerContent, { hover, selected })) : React__default.createElement(InnerContent, { hover, selected });
    return React__default.createElement("div", { className: styles.rowWrapper, "data-selected": Boolean(selected), "data-zds": true }, innerContent);
  };
  return React__default.createElement(PageNavigationRow, { content: Content, item, onSelect });
}

export { NonNestedRow as default };
//# sourceMappingURL=NonNestedRow.es.js.map
